import React from 'react';
import { Navigate, Route, Routes } from "react-router-dom";

import HomeDashPage from './Pages/Dashboard/Home';
import Login from './Pages/Dashboard/Login';
import ManagerPastDues from './Pages/Dashboard/ManagerPastDues';
import PastDue from './Pages/Dashboard/PastDue';
import CommunicationDispatcher from './Pages/Dashboard/CommunicationDispatcher';
import BilletMethods from './Pages/Mobile/BilletMethods';
import Email from './Pages/Mobile/Email';
import Feedback from './Pages/Mobile/Feedback';
import Home from './Pages/Mobile/Home';
import NoOffer from './Pages/Mobile/NoOffer';
import Offer from './Pages/Mobile/Offer';
import PastDueDate from './Pages/Mobile/PastDueDate';
import Payment from './Pages/Mobile/Payment';
import PaymentMethods from './Pages/Mobile/PaymentMethods';

import { Layout } from './Components';
import PortfolioAnalysis from './Container/Dashboard/PortfolioAnalysis';
import PortfolioAnalysisSingle from './Container/Dashboard/PortfolioAnalysis/single';
import Confirmation from './Container/Mobile/Confirmation';
import PastDueDetails from './Pages/Dashboard/PastDueDetails';
import CampaignHistory from './Pages/CampaignHistory';
import ProtectedRoute from './protectRoute';

// Operator
import OperatorHome from './Pages/Dashboard/Operator/Home';
import Team from './Pages/Dashboard/Team';
import ForgotPassword from './Container/Dashboard/ForgotPassword';
import TokenInputPage from './Container/Dashboard/TokenInputPage';
import ResetPasswordNew from './Container/Dashboard/ResetPassword';
import TwoFAToken from './Container/Dashboard/TwoFAToken';
import HumanChat from './Container/Dashboard/HumanChat/humanChat';

window.addEventListener('load', () => {
  const primaryColor = localStorage.getItem('primaryColor');
  const secondaryColor = localStorage.getItem('secondaryColor');
  const logo = localStorage.getItem('logo');

  if (primaryColor) {
    document.documentElement.style.setProperty('--portal-header-primary', primaryColor);
  }
  if (secondaryColor) {
    document.documentElement.style.setProperty('--portal-header-secondary', secondaryColor);
  }
  if (logo) {
    document.documentElement.style.setProperty('--portal-logo', logo);
  }
});

const App = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="forgot-password" element={<ForgotPassword />} />
      <Route path="inputToken" element={<TokenInputPage />} />
      <Route path="twofa-token" element={<TwoFAToken />} />
      <Route path="reset-password/new" element={<ResetPasswordNew />} />
      <Route path="dashboard">
        <Route path="home" element={<ProtectedRoute><Layout dashBoard><HomeDashPage /></Layout></ProtectedRoute>} />
        <Route path="team" element={<ProtectedRoute><Layout dashBoard><Team /></Layout></ProtectedRoute>} />
        <Route path="past-due" element={<ProtectedRoute><Layout dashBoard><PastDue /></Layout></ProtectedRoute>} />
        <Route path="past-due/import" element={<ProtectedRoute><Layout dashBoard><PastDue /></Layout></ProtectedRoute>} />
        <Route path="past-due/import/bulk" element={<ProtectedRoute><Layout dashBoard><PastDue /></Layout></ProtectedRoute>} />
        <Route path="portfolio-analysis" element={<ProtectedRoute><Layout dashBoard><PortfolioAnalysis /></Layout></ProtectedRoute>} />
        <Route path="portfolio-analysis-single" element={<ProtectedRoute><Layout dashBoard><PortfolioAnalysisSingle /></Layout></ProtectedRoute>} />
        <Route path="manager-pastdues" element={<ProtectedRoute><Layout dashBoard><ManagerPastDues /></Layout></ProtectedRoute>} />
        <Route path="communication-dispatcher" element={<ProtectedRoute><Layout dashBoard><CommunicationDispatcher /></Layout></ProtectedRoute>} />
        <Route path="details" element={<ProtectedRoute><Layout dashBoard><PastDueDetails /></Layout></ProtectedRoute>} />
        <Route path="home-operator" element={<ProtectedRoute><Layout dashBoard><OperatorHome /></Layout></ProtectedRoute>} />
        <Route path="chat-human/:personalNumber" element={<ProtectedRoute><Layout dashBoard><HumanChat /></Layout></ProtectedRoute>}/>
        <Route path="campaign-history" element={<ProtectedRoute><Layout dashBoard><CampaignHistory /></Layout></ProtectedRoute>} />
      </Route>
      <Route path="offers" >
        <Route path="customer" element={<Home />} />
        <Route path="customer/:id" element={<Offer />} />
        <Route path="customer/:id/no-offer" element={<NoOffer />} />
        <Route path="customer/:id/past-due-date/:pastDueOption/payment/:offerId" element={<PastDueDate />} />
        <Route path="customer/:id/past-due-date/:pastDueOption/payment/:offerId/installment-day/:installmentDay" element={<Confirmation />} />
        {/* <Route path="customer/:id/past-due-date/:pastDueOption/payment/:offerId/installment-day/:installmentDay" element={<PaymentMethods />} /> */}
        <Route path="customer/:id/past-due-date/:pastDueOption/payment/:offerId/installment-day/:installmentDay/method/:method/billetmethods" element={<BilletMethods />} />
        <Route path="customer/:id/past-due-date/:pastDueOption/payment/:offerId/installment-day/:installmentDay/method/:method/billetmethods/method/:method/" element={<Payment />} />
        <Route path="customer/:id/past-due-date/:pastDueOption/payment/:offerId/installment-day/:installmentDay/method/:method/billetmethods/email" element={<Email />} />
        <Route path="customer/:id/past-due-date/:pastDueOption/payment/:offerId/installment-day/:installmentDay/method/:method/billetmethods/email/feedback" element={<Feedback />} />

        <Route path="customer/:id/payment-methods/:offerId/installments/:installment" element={<PaymentMethods />} />
        <Route path="customer/:id/payment-methods/:offerId/installments/:installment/method/:method/billetmethods" element={<BilletMethods />} />
        <Route path="customer/:id/payment-methods/:offerId/installments/:installment/method/:method/billetmethods/method/:method/" element={<Payment />} />
        <Route path="customer/:id/payment-methods/:offerId/installments/:installment/method/:method/billetmethods/email" element={<Email />} />
        <Route path="customer/:id/payment-methods/:offerId/installments/:installment/method/:method/billetmethods/email/feedback" element={<Feedback />} />
      </Route>
      <Route path="*" to="/" element={<Navigate to="/login" replace />} />
    </Routes>
  )
}

export default App
